import React, { useState, useEffect } from "react";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Image from "components/Elements/Image/Image.tsx";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import EmbedLimitOptionsModal from "components/Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";

const Security = ({
  protectFormWithPassword,
  setProtectFormWithPassword,
  passwordForm,
  setPasswordForm,
  setUpdateBeforeSave,
  emptyPassword,
  setEmptyPassword,
  allowAccess,
  setAllowAccess,
  displayToSubUsers,
  setDisplayToSubUsers,
  displayTypeSubUsers,
  setDisplayTypeSubUsers
}) => {
  const { getTextByKey } = useContent();
  const { isPremium, isBusiness } = useUser();
  const { setModal } = useModal();
  const [tempFocusPassword, setTempFocusPassword] = useState(null);
  const [tempBlurPassword, setTempBlurPassword] = useState(null);
  const [updatePassword, setUpdatePassword] = useState(false);
  const [oldProtectWithPassword, setOldProtectWithPassword] = useState(
    protectFormWithPassword
  );
  const [oldAllowAccess, setOldAllowAccess] = useState(allowAccess);
  useEffect(() => {
    if (tempBlurPassword !== tempFocusPassword && protectFormWithPassword) {
      setUpdatePassword(true);
    }
  }, [tempBlurPassword]);

  const handleChangePassword = (e) => {
    setEmptyPassword(false);
    setPasswordForm(e);
  };

  const handleChangeProtectFormWithPassword = () => {
    if (isPremium()) {
      setProtectFormWithPassword((prev) => !prev);
      setPasswordForm("");
      setEmptyPassword(false);
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };  

  const handleChangeAllowAccess = () => {
    if (isPremium()) {
      setAllowAccess((prev) => !prev);
      setUpdatePassword(true);
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  const handleChangeDisplaySubUsers = () => {
    if (isBusiness() || isPremium()) {
      setDisplayToSubUsers((prev) => !prev);
      setUpdatePassword(true);
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  const handleChangeDisplayTypeSubUsers = (e) => {
    setDisplayTypeSubUsers(e);
  };

  useEffect(() => {
    if (updatePassword) {
      setUpdateBeforeSave({ mode: true, action: "updatePassword" });
      setUpdatePassword(false);
      setOldProtectWithPassword(protectFormWithPassword);
      setOldAllowAccess(allowAccess);
    }
  }, [updatePassword]);

  useEffect(() => {
    if (!protectFormWithPassword && oldProtectWithPassword) {
      setUpdatePassword(true);
    }
  }, [protectFormWithPassword]);


  const DisplayToTypeOfSubUsers = {
    "display-to-all-sub-users": "All",
    "display-to-admin-and-supervisor": "AdminAndSupervisor",
    "display-to-admin": "Admin"
  }

  return (
    <div className="security-container option">
      <div className="input-status-div">
        <Image
          alt=""
          title=""
          className="input-checkbox"
          onClick={(e) => {
            handleChangeProtectFormWithPassword();
          }}
          name={
            isPremium()
              ? protectFormWithPassword
                ? "checkbox-checked"
                : "checkbox-unchecked"
              : "checkbox-unchecked"
          }
          ext="svg"
        />
        <span className="span-text">
          {getTextByKey("protect-with-password-checkbox")}
        </span>{" "}
        <Tooltip
          id={"protect-form"}
          tooltipTextKey="protect-with-password-tooltip"
          //hardPositioned
          top
        >
          <Icon name="question-circle" iconClass="tooltip-question" />
        </Tooltip>
      </div>
      <div
        className={`password-input ${
          !protectFormWithPassword ? "hide-password-input" : ""
        }`}
      >
        <div className="text">{getTextByKey("set-password")}</div>
        <div
          className={`input ${!protectFormWithPassword ? "disabled" : ""} ${
            emptyPassword ? "empty-password" : ""
          }`}
        >
          <input
            onFocus={(e) => setTempFocusPassword(e.target.value)}
            onBlur={(e) => setTempBlurPassword(e.target.value)}
            disabled={!protectFormWithPassword}
            type="text"
            value={isPremium() ? passwordForm : ""}
            onChange={(e) => {
              handleChangePassword(e.target.value);
            }}
          />
          {emptyPassword && (
            <div className="invalid-alert-text">
              {getTextByKey("empty-password")}
            </div>
          )}
        </div>
      </div>
      <div className="allow-access-container">
        <div className="input-status-div">
          <Image
            alt=""
            title=""
            className="input-checkbox"
            onClick={(e) => {
              handleChangeAllowAccess();
            }}
            name={
              isPremium()
                ? allowAccess
                  ? "checkbox-checked"
                  : "checkbox-unchecked"
                : "checkbox-unchecked"
            }
            ext="svg"
          />
          <span className="span-text">
            {getTextByKey("create-form-allow-access-text")}
          </span>{" "}
          <Tooltip
            id={"allow-access-to-form"}
            tooltipTextKey="create-form-allow-access-tooltip"
            //hardPositioned
            top
          >
            <Icon name="question-circle" iconClass="tooltip-question" />
          </Tooltip>
        </div>
      </div>
      <div className="display-sub-users-container">
        <div className="input-status-div">
          <Image
            alt=""
            title=""
            className="input-checkbox"
            onClick={(e) => {
              handleChangeDisplaySubUsers();
            }}
            name={
              (isBusiness() || isPremium())
                ? displayToSubUsers
                  ? "checkbox-checked"
                  : "checkbox-unchecked"
                : "checkbox-unchecked"
            }
            ext="svg"
          />
          <span className="span-text">
            {getTextByKey("create-form-display-to-sub-users-text")}
          </span>{" "}
          <Tooltip
            id={"display-to-sub-users"}
            tooltipTextKey="create-form-display-to-sub-users-tooltip"
            //hardPositioned
            top
          >
            <Icon name="question-circle" iconClass="tooltip-question" />
          </Tooltip>
        </div>
        
        {
          displayToSubUsers && (
            <div className="display-sub-users-type">
            <select
              value={displayTypeSubUsers}
              onChange={(e) => {
                handleChangeDisplayTypeSubUsers(e.target.value);
              }}
            >
              {Object.keys(DisplayToTypeOfSubUsers).map((item, i) => (
                  <option
                    value={DisplayToTypeOfSubUsers[item]}
                    key={i}
                  >
                  {getTextByKey(item)}
                  </option>
                ))}
            </select>
          </div>
          )
        }
      </div>
    </div>
  );
};

export default Security;
